import { render } from "./SetUpAws.vue?vue&type=template&id=a4faac38"
import script from "./SetUpAws.vue?vue&type=script&lang=js"
export * from "./SetUpAws.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1392100202/src/saas/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__